export interface ProjectHoursAndRevenue {
	totalQuotedHours: number;
	totalRevenue: number;
	totalWonHours: number;
}
